import Vue from 'vue';
import notifyFunction from "../ms-notification/notifyFunction.js"
import vsNotifications from './MsNotification.vue'

const NotiConstructor = Vue.extend(vsNotifications);


let instance;
export const notify = (parameters) => {
    if (parameters.fullWidth) {
        if (parameters.position) {
            parameters.position = parameters.position.replace('right', 'left')
        }
    }
    instance = new NotiConstructor({
        data: parameters,
    });
    instance.vm = instance.$mount();
    parameters.click ? instance.vm.$on('click', parameters.click) : null
    notifyFunction.insertBody(instance.vm.$el);
}
